import {
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { EUserGroupRole } from '@/client/legacy-shared-modules/user-group-link/user-group-role';
import { SelectButton } from '@/components/SelectButton';
import { READABLE_USER_ROLE_FOR_GROUP } from '@/utilities';

export const GroupRoleSelect = React.forwardRef<
  HTMLButtonElement,
  {
    value?: EUserGroupRole;
    onChange: (value: EUserGroupRole) => void;
  } & Omit<React.ComponentProps<typeof SelectButton>, 'value' | 'onChange'>
>(({ value, onChange, ...props }, ref) => {
  return (
    <Menu>
      <MenuButton as={SelectButton} {...props} ref={ref}>
        {value ? READABLE_USER_ROLE_FOR_GROUP[value] : 'Select a Role'}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup type="radio" value={value} onChange={onChange}>
          <MenuItemOption value={EUserGroupRole.GroupAdmin}>
            {READABLE_USER_ROLE_FOR_GROUP[EUserGroupRole.GroupAdmin]}
          </MenuItemOption>
          <MenuItemOption value={EUserGroupRole.GroupModerator}>
            {READABLE_USER_ROLE_FOR_GROUP[EUserGroupRole.GroupModerator]}
          </MenuItemOption>
          <MenuItemOption value={EUserGroupRole.GroupMember}>
            {READABLE_USER_ROLE_FOR_GROUP[EUserGroupRole.GroupMember]}
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
});

GroupRoleSelect.displayName = 'GroupRoleSelect';
